import { useQuery } from "@tanstack/react-query";
import { TRecentCharge } from "../../models/RecentCharge";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IRecentChargesData } from "../types";
import { InvoiceService } from "../../services/invoice.service";

export const useGetRecentChargesQuery = (data: IRecentChargesData) => {
  return useQuery<{ data: TRecentCharge[] }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_RECENT_CHARGES, data],
    queryFn: () => InvoiceService.getRecentCharges(data).then((res) => res.data),
  });
};
